import {Ufs} from '../Modelos/Ufs';

export class Cidades
{
    id_cid: number = 0;
    nome_cid: string = '';
    codibge_cid: string = '';
    uf: Ufs = new Ufs();
}